import axios from 'axios';
import { API_BASE_URL } from 'constants/ApiConstant';
import { AUTH_TOKEN } from 'constants/AuthConstant';

const axiosInstance = axios.create({
    baseURL: API_BASE_URL,
});

axiosInstance.interceptors.request.use(config => {
    const token = localStorage.getItem(AUTH_TOKEN);
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

axiosInstance.interceptors.response.use(
    res => res,
    err => {
        const token = localStorage.getItem(AUTH_TOKEN);
        const status = err?.response?.status;

        if ((status === 401 || status === 403) || !token) {
            localStorage.clear();
            window.location.href = '/';
        }

        return Promise.reject(new Error (err));
    }
);

export default axiosInstance;
